import { PrinterPosCogOutlineIcon } from './PrinterPosCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 7D634FE7-3A63-4850-9AC4-B62775160D58
 * name printer-pos-cog-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-cog-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleCogOutlineIcon = PrinterPosCogOutlineIcon;
export default PrinterPointOfSaleCogOutlineIcon